// extracted by mini-css-extract-plugin
export default {"layout":"Main_layout__90BjS","content":"Main_content__8V5Hp"};